export default "__VITE_ASSET__CQrztfSW__"